import { useEffect, useMemo, useState } from 'react'

import { notify } from '~/BugSnag'

import type { Locale } from './@types'
import en from './en.json'
import { getMessages } from './services'

export const useMessages = (locale: Locale) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<Record<string, string>>(en)
  const [language] = locale.split('-')

  const loaded = useMemo(() => {
    return !!data
  }, [data])

  useEffect(() => {
    if (language === 'en') return

    setLoading(true)

    getMessages(language)
      .then(setData)
      .catch((error: unknown) => {
        notify?.(error instanceof Error ? error : new Error(String(error)))
      })
      .finally(() => {
        setLoading(false)
      })
  }, [language])

  return {
    loading,
    loaded,
    data,
  }
}
